import React from "react";
import { useDispatch } from "react-redux";
import { setPopupComponent } from "../../store/slices/ui";
import classNames from "classnames";

function TermsCondition({ show }) {
  const dispatch = useDispatch();

  return (
    <div
      id="popup-term"
      className={classNames("popup-container", { "show-popup": show })}
    >
      <div className="popup-content" tabIndex={0}>
        <a
          onClick={() => dispatch(setPopupComponent(null))}
          href="#"
          className="close"
        >
          &times;
        </a>

        <h3>Terms & Conditions</h3>
        <div class="content-scroll-popup">
          <p>
            Please read these Terms and Conditions ("Terms") carefully before
            using our application ("App"). These Terms govern your access to and
            use of the App, its features, and any related services provided by
            the App's owners or operators. By using the App, you agree to be
            bound by these Terms. If you do not agree with any part of these
            Terms, please refrain from using the App.
          </p>
          <ol class="terms-content">
            <li>
              <p>
                App Purpose and Scope:
                <br />
                a. The App is intended to provide general information about your
                mental health.
                <br />
                b. The App does not provide medical advice or diagnosis. Any
                information provided within the App should not be considered a
                substitute for professional medical advice or consultation.
                Always consult a qualified healthcare professional for medical
                concerns or advice.
              </p>
            </li>
            <li>
              <p>
                User Eligibility:
                <br />
                a. By using the App, you confirm that you are at least 18 years
                old or have reached the age of majority in your jurisdiction.
                <br />
                b. If you are using the App on behalf of a minor, you must be
                their parent or legal guardian and accept these Terms on their
                behalf.
              </p>
            </li>
            <li>
              <p>
                User Account:
                <br />
                a. To use certain features of the App, you may be required to
                create a user account.
                <br />
                b. You are responsible for maintaining the confidentiality of
                your account credentials and are solely responsible for any
                activities that occur under your account.
                <br />
                c. You agree to provide accurate and up-to-date information
                during the registration process and to promptly update any
                changes to your information.
              </p>
            </li>
            <li>
              <p>
                App Content:
                <br />
                a. The App may contain information, materials, or resources
                provided by third parties. We strive to ensure the accuracy and
                reliability of such content but do not guarantee its
                completeness or endorse its accuracy.
                <br />
                b. The App's owners or operators are not responsible for any
                reliance placed on such information or materials, and your use
                of such content is at your own risk.
              </p>
            </li>
            <li>
              <p>
                Privacy and Data Security:
                <br />
                a. Your privacy is important to us. The App's privacy policy
                outlines how we collect, use, and protect your personal
                information.
                <br />
                b. By using the App, you consent to the collection, use, and
                storage of your information as described in the privacy policy.
              </p>
            </li>
            <li>
              <p>
                User Responsibilities:
                <br />
                a. You agree to use the App in compliance with applicable laws
                and regulations.
                <br />
                b. You will not use the App for any illegal, unauthorized, or
                unethical purposes, including but not limited to spreading
                malware, attempting to gain unauthorized access, or interfering
                with the App's functionality or security.
                <br />
                c. You are solely responsible for any content you post, upload,
                or transmit through the App. You must ensure that such content
                complies with applicable laws and does not infringe on the
                rights of any third party.
              </p>
            </li>
            <li>
              <p>
                Intellectual Property:
                <br />
                a. All intellectual property rights related to the App,
                including but not limited to copyrights, trademarks, and trade
                secrets, belong to the App's owners or operators.
                <br />
                b. You may not copy, modify, distribute, transmit, display,
                perform, or create derivative works of any part of the App
                without prior written consent from the App's owners or
                operators.
              </p>
            </li>
            <li>
              <p>
                Disclaimers and Limitation of Liability:
                <br />
                a. The App is provided on an "as-is" basis without any
                warranties, whether express or implied, including but not
                limited to warranties of merchantability, fitness for a
                particular purpose, or non-infringement.
                <br />
                b. The App's owners or operators shall not be liable for any
                direct, indirect, incidental, consequential, or exemplary
                damages arising out of or in connection with your use of the
                App.
              </p>
            </li>
            <li>
              <p>
                Modification and Termination:
                <br />
                a. The App's owners or operators reserve the right to modify or
                terminate the App, its features, or these Terms at any time
                without prior notice.
                <br />
                b. You may terminate your use of the App at any time by
                uninstalling the App and discontinuing its use.
              </p>
            </li>
            <li>
              <p>
                Governing Law and Jurisdiction:
                <br />
                a. These Terms shall be governed by and construed by the laws of
                the State of Delaware.
                <br />
                b. Any disputes arising out of or relating to these Terms or the
                use of the App shall be subject to the exclusive jurisdiction of
                the appropriate state courts located in the State of Delaware.
              </p>
            </li>
          </ol>
          <p>
            By using the App, you acknowledge that you have read, understood,
            and agreed to these Terms and Conditions. If you do not agree to
            these Terms, you should not use the App.
          </p>
        </div>
      </div>
    </div>
  );
}

export default TermsCondition;
